export default __webpack_public_path__ + "static/media/pag28.3c2c4120.jpg";